export default  {
    inserted(el,binding,vnode){
        const value=binding.value;
        const context = el.__context={
            startX:0,
            startY:0,
            mousedown(event){
                context.startX=event.pageX;
                context.startY=event.pageY;
                value.mousedown.call(vnode.context,binding.arg);
                document.addEventListener("mousemove",context.mousemove);
                document.addEventListener("mouseup",context.mouseup);
                event.preventDefault();
            },
            mousemove(event){
                const offsetX=event.pageX-context.startX;
                const offsetY=event.pageY-context.startY;
                context.startX=event.pageX;
                context.startY=event.pageY;
                value.mousemove.call(vnode.context,{offsetX,offsetY});
                event.preventDefault();
            },
            mouseup(event){
                const offsetX=event.pageX-context.startX;
                const offsetY=event.pageY-context.startY;
                value.mousemove.call(vnode.context,{offsetX,offsetY});
                context.startX=0;
                context.startY=0;
                document.removeEventListener("mousemove",context.mousemove);
                document.removeEventListener("mouseup",context.mouseup);
                event.preventDefault();
                if(el.parentNode)el.parentNode.focus();
            }
        };
        el.addEventListener("mousedown",context.mousedown)
    },
    unbind(el){
        el.removeEventListener("mousedown",el.__context.mousedown);
        el.__context=null;
    }
}

